// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Plugins
import { formatValueWithUnit } from '../../../../../../../../plugins/general';
import {
  automationTypeToTagType,
  automationTypeToText,
} from '../../../../../../../../plugins/crusher';

// Components
import { EquipmentSensorListItem } from '../../../../../../../../components/EquipmentSensorList';
import { Col } from '../../../../../../../../layout/elements/Col';
import { Tag } from '../../../../../../../../layout/elements/Tag';
import { Row } from '../../../../../../../../layout/elements/Row';

// Module
import { ListModule } from '../../../ListModule';

// View
import { AutomationProps } from './Automation.types';
import { Container, ListContainer } from './Automation.style';

function Automation({
  className,
  edgeStatus,
  testId,
  unitData,
}: AutomationProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();

  const autoBowlItems: EquipmentSensorListItem[] = [
    {
      sensor: `${t('view.crusher.vsi.maintenance.setpoint.automation.hybridLevelPower')}`,
      setpoint: (
        <Tag
          text={automationTypeToText(unitData?.automationType)}
          type={automationTypeToTagType(
            unitData?.automationType,
            edgeStatus?.edgeStatus ? edgeStatus?.edgeStatus : null,
            unitData?.timestamp,
          )}
        />
      ),
    },
    {
      sensor: `${t('view.crusher.vsi.maintenance.setpoint.automation.crusherCurrent')}`,
      setpoint: formatValueWithUnit(unitData?.spCrusherMotorAutoAmps, 'A'),
    },
    {
      sensor: `${t('view.crusher.vsi.maintenance.setpoint.automation.binFeederHighWarning')}`,
      setpoint: formatValueWithUnit(unitData?.spBinFeederHighWarning, '%'),
    },
  ];

  return (
    <Container className={className} data-testid={testId}>
      <Row>
        <Col cols={12}>
          <ListContainer>
            <ListModule
              title={`${t('view.crusher.vsi.maintenance.setpoint.automation.title')}`}
              items={autoBowlItems}
            />
          </ListContainer>
        </Col>
      </Row>
    </Container>
  );
}

export { Automation };
